import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import VueTelInput from 'vue-tel-input'
import ServerError from './components/Common/500'
import StarRating from 'vue-star-rating'

Vue.component('star-rating', StarRating);
Vue.component('VueElementLoading', VueElementLoading)
Vue.component('ServerError', ServerError)
Vue.use(VueTelInput)

var VueScrollTo = require('vue-scrollto');
Vue.config.productionTip = false


Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
window.axios = require('axios')

// axios.defaults.headers.Common['x-auth-token'] = localStorage.getItem('token')
// Vue.prototype.baseURL = 'http://192.168.48.157:9000'; // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://192.168.48.157:9000'; // Production URL
 Vue.prototype.baseURL = 'http://13.235.2.39'; // URL for File retriving Globaly initialized
axios.defaults.baseURL = 'http://13.235.2.39';
Vue.prototype.googleAPIKey = 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw'
// axios.defaults.timeout = 60000;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
